import type { IconData } from '@stacksjs/iconify-core'

export const contentPrint: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M4 0h8v4h4v10h-2.5V8.5h-11V14H0V4h4z\"/><path fill=\"currentColor\" d=\"M12 10H4v6h8z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default contentPrint
